var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "280",
      "overlay-color": "rgba(39, 50, 64)",
      "overlay-opacity": "0.6",
      "persistent": "",
      "transition": false
    },
    model: {
      value: _vm.qrCodeDialog,
      callback: function ($$v) {
        _vm.qrCodeDialog = $$v;
      },
      expression: "qrCodeDialog"
    }
  }, [_c('div', {
    staticClass: "qrcode-modal"
  }, [_c('IconCustom', {
    staticClass: "close-icon",
    attrs: {
      "name": "icn24_close",
      "color": "#CCD1E3"
    },
    nativeOn: {
      "click": function ($event) {
        _vm.qrCodeDialog = false;
      }
    }
  }), _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("paymentProcess.step3.QRcode")))])]), _c('div', {
    staticClass: "description"
  }, [_c('qrcode', {
    staticClass: "qr-code",
    attrs: {
      "value": _vm.value,
      "options": {
        width: 200,
        margin: 0
      }
    }
  })], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }